import { useCallback, useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import __ from "src/utils/Translations";
import { NewLinkFormModels } from "src/Pages/Company/Dashboard/pages/Widgets/NewLinkForm/NewLinkForm.models";
import { UnformattedWidgetLink } from "./MainFormLinkForm.models";

interface UseLinkModalActionsParams {
  formMethods: UseFormReturn<NewLinkFormModels>;
  onSubmit: (value: UnformattedWidgetLink) => void;
  resetModal: () => void;
  submitLabel?: string;
  beforeSubmit?: () => Promise<void>;
  onCancel?: () => void;
  isCropping?: boolean;
}

const useLinkModalActions = ({
  formMethods,
  onSubmit,
  resetModal,
  submitLabel = __("Dodaj") as string,
  beforeSubmit,
  onCancel,
  isCropping = false,
}: UseLinkModalActionsParams) => {
  const { isValid, isDirty } = formMethods.formState;

  const handleSubmit = useCallback(async () => {
    if (beforeSubmit) {
      await beforeSubmit();
    }
    const valid = await formMethods.trigger();
    if (!valid) return;
    const { name, url, icon, iconId } = formMethods.getValues();
    onSubmit({ fileId: iconId ?? null, name, url, icon });
    formMethods.reset();
    resetModal();
  }, [formMethods, onSubmit, resetModal, beforeSubmit]);

  return useMemo(
    () => [
      {
        label: __("Anuluj") as string,
        variant: "outlined" as const,
        callbackFn: (): void => {
          onCancel?.();
          formMethods.reset();
          resetModal();
        },
      },
      {
        label: submitLabel,
        variant: "contained" as const,
        disabled: isCropping ? false : !isDirty || !isValid,
        callbackFn: handleSubmit,
      },
    ],
    [isValid, isDirty, formMethods, resetModal, handleSubmit, submitLabel, onCancel, isCropping]
  );
};

export default useLinkModalActions;
